module.exports = __webpack_public_path__ + "static/media/location icon.b9f8b3ae.svg";